import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { CheckoutFormSchema } from '../schema';

interface IProps {
  onBack: () => void;
}

export default function StepAdditionalInformation(props: IProps) {
  const { t } = useTranslation();
  const { control, register } = useFormContext<CheckoutFormSchema>();

  const shippingId = useWatch({ control, name: 'shippingMethodId' });
  const paymentId = useWatch({ control, name: 'paymentMethodId' });

  return (
    <div className="max-w-md w-full flex flex-col gap-y-8">
      <div className="form-field">
        <label htmlFor="note">{t('OrderNote')}</label>
        <div className="input">
          <textarea {...register('note')} id="note" className="w-full h-24"></textarea>
        </div>
      </div>

      <div className="flex justify-between gap-x-4">
        <button type="button" className="btn btn-back" onClick={props.onBack}>
          {t('GoBack')}
        </button>
        <button
          type="submit"
          className="btn btn-primary w-full tablet:w-[16rem]"
          disabled={!shippingId || !paymentId}>
          {t('ToContinue')}
        </button>
      </div>
    </div>
  );
}
